import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useToast, Center, HStack, Text } from '@chakra-ui/react';
import { FlexBar, IconHistory, IconList } from '../common';
import { Image } from "@chakra-ui/react";
import ChkoutLinkWithNoButton from './ChkoutLinkWithNoButton';
import { BASE_URL } from '../configs/configs';
import { getVersions } from '../states/useVersionsStore';
import { getLocId } from '../states/locationActions';
import { getLocation } from '../states/prefsActions';
import { useStore } from '../states/useStore';

const infoToast = toast => message => {
  toast({
    title: message,
    status: 'info',
    duration: 5000,
    isClosable: true,
    position: 'top'
  });
};

const instore = process.env.REACT_APP_PAYMENT_TYPE === 'instore';

const Header = () => {
  const toast = useToast();
  const info = infoToast(toast);

  const loc = useLocation();
  const isCheckout = () => loc.pathname === '/checkout';

  const { versions: { appVersion, dataVersion } } = getVersions();

  // this deployment's single locId (see prefsActions.js) drives which
  // location's name/logo shows here — nothing else distinguishes brands
  // that share this codebase (see ECOM-architecture-audit.md).
  const locId = useStore(state => state.locId);
  const location = getLocation(locId);

  // public/index.html's <title> is a static "HAPPY ROLL" build-time
  // fallback — this is what actually keeps the browser tab/bookmark name
  // in sync with whichever brand this locId resolves to.
  useEffect(() => {
    if (location) document.title = location.name;
  }, [location]);

  const imageClick = () => info(`Versions: ${appVersion}-${dataVersion} | ${getLocId()}`);

  if (isCheckout()) {
    return <HeaderCheckout />;
  }
  return (
    <FlexBar>
      <Center><Image onClick={imageClick} p='0' h='60px' src={location ? `${BASE_URL}${location.logo}` : undefined} /></Center>
      <Text fontSize='1.4rem' fontWeight='600' color='red.700' onClick={imageClick}>
        {location ? location.name : ''}
      </Text>
      {
        instore &&
        <Text fontSize='1.6rem' fontWeight='600' color='gray.700'>
          INSTORE ORDERING
        </Text>
      }
      <HStack>
        {!instore && <Link to='/orders'><IconHistory /></Link>}
        <Link to='/'><IconList /></Link>
        <ChkoutLinkWithNoButton />
      </HStack>
    </FlexBar>
  );
};
export default Header;

const HeaderCheckout = () => {
  return (
    <FlexBar>
      <Center w='full' p='3'>
        <Text fontWeight='600' fontSize='2xl' color='red.600'>
          Checkout
        </Text>
      </Center>
    </FlexBar>
  );
};
